import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarkerAlt, faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <div className="site-footer bg-dark text-white">
      <div className="container py-5">
        <div className="row">
          <div className="col-md-6 mb-4 mb-md-0 poppins-semibold">
            <h2 className="footer-heading">
              OnPoint Services: Your trusted partner for reliable maintenance & repairs.
            </h2>
          </div>

          <div className="col-md-6">
            <p>
              <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2" />
              3957 Christopher Dr. Vestavia, AL 35243
            </p>
            <p>
              <FontAwesomeIcon icon={faPhone} className="me-2" />
              <a href="tel:+12059416322" className="text-white text-decoration-none">
                (205) 941-6322
              </a>
            </p>
            <p>
              <FontAwesomeIcon icon={faEnvelope} className="me-2" />
              <a href="mailto:info@on-point-services.com" className="text-white text-decoration-none">
                info@on-point-services.com
              </a>
            </p>
          </div>
        </div>

        <hr className="footer-divider my-4" />

        <div className="row align-items-center">
          <div className="col-md-8">
            <ul className="footer-nav list-unstyled d-flex gap-3 mb-0 poppins-regular mb-2">
              <li><a href="/" className="text-white">Home</a></li>
              <li><a href="/aboutus" className="text-white">About Us</a></li>
              <li><a href="/contactus" className="text-white">Contact Us</a></li>
            </ul>
          </div>

          <div className="col-md-4 text-md-end footer-copy poppins-regular">
            © OnPoint Services {currentYear}, All Rights Reserved.
          </div>
        </div>
      </div>
    </div>
  )
}
